import {useOutletContext} from 'react-router-dom';
import {Box, Paper, Typography} from '@mui/material';

import {useGetReferralProgress} from '@entities/referral';
import {BaseWidgetLayout} from '@widgets/common';
import {ReferralsTable} from '@widgets/referral';
import {UserAccountOutletContext} from './types';

export const ReferralsTab = () => {
  const {user} = useOutletContext<UserAccountOutletContext>();
  const {data, isPending, error} = useGetReferralProgress(user.id);

  return (
    <>
      <BaseWidgetLayout isPending={isPending} error={error}>
        {data && (
          <Box display="flex" flexWrap="wrap" gap={2} mb={3}>
            {[
              {label: 'Registered', value: data.registeredCount},
              {label: 'KYC completed', value: data.kycCompletedCount},
              {label: 'Deposited', value: data.depositedCount},
              {label: 'Inactive', value: data.inactiveCount},
            ].map(({label, value}) => (
              <Paper
                key={label}
                variant="outlined"
                sx={{
                  p: 2,
                  flex: '1 1 150px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.5,
                }}
              >
                <Typography color="text.secondary">{label}</Typography>
                <Typography sx={{fontSize: 24}}>{value}</Typography>
              </Paper>
            ))}
          </Box>
        )}
      </BaseWidgetLayout>
      <ReferralsTable userId={user.id} />
    </>
  );
};
